<template>
  <a-modal
      title="休假记录"
      :visible="holidayVisible"
      @cancel="$emit('cancel')"
      @ok="$emit('success')"
      width="80%"
  >
    <s-table
        ref="holidayTable"
        :columns="columns"
        :data="loadData"
        :rowKey="record => record.id"
        :pagination="{ showTotal: (total) => `共 ${total} 条` }"
    >
    </s-table>
  </a-modal>
</template>
<script>
import STable from '@/components/Table'
import { QueryExpertLeaveRecord } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import moment from 'moment/moment'
import { IsLeaveRecord } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'

const columns = [
  {
    title: '填报日期',
    dataIndex: 'addTime',
    customRender: (text) => {
      return text && moment(text).format('YYYY-MM-DD')
    }
  },
  {
    title: '休假开始日期',
    dataIndex: 'leaveStartTime',
    customRender: (text) => {
      return text && moment(text).format('YYYY-MM-DD')
    }
  },
  {
    title: '休假结束日期',
    dataIndex: 'leaveEndTime',
    customRender: (text) => {
      return text && moment(text).format('YYYY-MM-DD') || '长期'
    }
  },
  {
    title: '休假原因',
    dataIndex: 'leaveReason',
    align: 'left',
  },
  {
    title: '状态',
    customRender: (text, record) => {
      return record.state === '0' && (record.leaveStartTime && !record.leaveEndTime || record.leaveEndTime && moment().diff(moment(record.leaveEndTime),'days') < 1) ? '有效' : '已结束'
    }
  },
]
export default {
  name: 'ExpertHolidayRecord',
  computed: {},
  components: {
    STable,
  },
  props: {
    expertId: {
      type: String,
      default: ''
    },
    holidayVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      columns,
      loadData: async (parameter) => {
        const data = {
          ...parameter,
          expertId: this.expertId,
        }
        return QueryExpertLeaveRecord(data)
      }
    }
  },
  watch: {
    holidayVisible (val) {
      if (val) {
        this.$refs.holidayTable?.refresh()
      }
    }
  },
  methods: {}
}
</script>
